import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface ParsicUsersState {
    list: any,
  }
  
const initialState:ParsicUsersState = {
    list:undefined,
}

export const ParsicUsersSlice = createSlice({
    name:"parsicUsers",
    initialState,
    reducers:{
        UpdateParsicUsers: (state,action) => {
            state.list = action.payload.parsicUsers;
        },
        AddParsicUser: (state,action) => {
            state.list = undefined;
        },
        EditParsicUser: (state,action) => {
            state.list = undefined;
        },
        RemoveParsicUser: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateParsicUsers,AddParsicUser,EditParsicUser,RemoveParsicUser} = ParsicUsersSlice.actions

export const selectparsicUsers = (state: RootState) => state.parsicUsers

export default ParsicUsersSlice.reducer;